import BaseController from "./base"

export default class extends BaseController {
  connect() {
    this.initializeTomSelect()
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }

  initializeTomSelect() {
    // Check if TomSelect is available
    if (typeof TomSelect !== 'undefined') {
      // Check if this field has errors
      const hasError = this.element.getAttribute('data-has-error') === 'true'
      
      // Get additional plugins from data attribute
      const additionalPlugins = this.element.getAttribute('data-tom-select-plugins')
      const plugins = {
        'clear_button': {
          title: 'Clear selection',
          className: 'clear-button'
        }
      }
      
      // Add remove_button plugin if requested (for multi-select)
      if (additionalPlugins && additionalPlugins.includes('remove_button')) {
        plugins['remove_button'] = {
          title: 'Remove this item'
        }
      }
      
      this.tomSelect = new TomSelect(this.element, {
        plugins: plugins,
        allowEmptyOption: true,
        placeholder: this.element.getAttribute('data-placeholder') || 'Select an option...',
        searchField: ['text'],
        highlight: false, // Disable default highlighting to preserve spaces
        hidePlaceholder: false, // Keep placeholder visible until user types
        hideSelected: false, // Show all options including currently selected
        onInitialize: function() {
          // Add error class if field has errors
          if (hasError) {
            this.control.classList.add('has-error')
            this.wrapper.classList.add('has-error')
          }
          // Update clear button visibility and placeholder
          if (this.getValue()) {
            this.control.classList.add('has-value')
            this.control_input.placeholder = '';
          } else {
            this.control.classList.remove('has-value')
            this.control_input.placeholder = this.settings.placeholder;
          }
        },
        onFocus: function() {
          // When focused, open dropdown and ensure input is ready for typing
          if (!this.isOpen) {
            this.open();
          }
          // Clear the input value and ensure it's focused and ready
          setTimeout(() => {
            if (this.control_input) {
              this.control_input.value = '';
              this.control_input.focus();
            }
          }, 10);
        },
        onBlur: function() {
          // Just let TomSelect handle blur naturally
        },
        onType: function(str) {
          // Clear placeholder when user starts typing
          if (str.length > 0) {
            this.control_input.placeholder = '';
          }
        },
        onChange: function() {
          // Update clear button visibility and placeholder based on whether there's a value
          if (this.getValue()) {
            this.control.classList.add('has-value')
            this.control_input.placeholder = '';
          } else {
            this.control.classList.remove('has-value')
            this.control_input.placeholder = this.settings.placeholder;
          }
        },
        render: {
          option: function(data, escape) {
            // Custom option renderer to preserve spaces and prevent highlighting issues
            return '<div>' + escape(data.text) + '</div>';
          },
          item: function(data, escape) {
            // Custom item renderer to preserve spaces
            return '<div>' + escape(data.text) + '</div>';
          },
          no_results: function(data, escape) {
            return '<div class="no-results">No results found</div>';
          }
        }
      })
    } else {
      // Retry after a short delay if TomSelect isn't loaded yet
      setTimeout(() => this.initializeTomSelect(), 100)
    }
  }
}